import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgIf } from '@angular/common';
import StrapiService from '../../services/strapi.service';
import {
  Header,
  IStrapiDocument,
  IStrapiDocuments,
} from '../../interfaces/strapi';
import { IStrapiImage } from '../../interfaces/strapi/strapi_image.interface';
import { UserService } from '../../services/user.service';

@Component({
    selector: 'app-accept-marketing-consent',
    templateUrl: './accept-marketing-consent.component.html',
    styleUrls: ['./accept-marketing-consent.component.scss'],
    imports: [NgIf],
})
export class AcceptMarketingConsentComponent implements OnInit {
  public pageData: MarketingConsentPage | undefined;

  public header: Header | undefined;

  public isLoading: boolean = true;

  public failed: boolean = false;

  constructor(
    private readonly route: ActivatedRoute,
    public readonly strapi: StrapiService,
    public readonly userService: UserService
  ) {
    this.strapi
      .getDocumentsByType('marketing-consent-page', { populate: '*' })
      .subscribe({
        next: (data: IStrapiDocument<MarketingConsentPage>) => {
          this.pageData = data.data.attributes;
        },
      });

    this.strapi.getHeaders().subscribe((data: IStrapiDocuments<Header>) => {
      this.header = this.parseHeaderData(data.data[0].attributes);
    });
  }

  ngOnInit(): void {
    const routeParams = this.route.snapshot.paramMap;
    const userUUID = String(routeParams.get('userUUID'));

    if (userUUID) {
      this.userService.acceptMarketingConsentByUUID(userUUID).subscribe({
        next: () => {
          this.isLoading = false;
        },
        error: () => {
          this.failed = true;
          this.isLoading = false;
        },
      });
    }
  }

  private parseHeaderData(page: Header): Header {
    const parsed = <Header>{};
    const theData = page;

    if (theData.logo) parsed.logo = theData.logo;

    return parsed;
  }
}

interface MarketingConsentPage {
  Title: string;
  message: string;
  image: IStrapiImage;
}
